export default function nudging(url) {
  let timeout;
  const icons = { positive: 'smile', neutral: 'meh', negative: 'frown' };

  return {
    url: url,
    editor: this.$refs.editor,
    timeout: null,
    showNudging: false,

    init() {
      // We listen for custom event 'commentInput' on the editor to pass the tinyMCE content
      this.$refs.editor.addEventListener('commentInput', (e) => this.handleCommentInput(e));
    },

    // To solve the 'this' problem, we use a wrapper function,
    // see: https://developer.mozilla.org/en-US/docs/Web/API/Window/setTimeout#the_this_problem
    handleCommentInput(e) {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        this.callAiFeedback(e);
      }, 1000);
    },

    type_from_url(url) {
      if (/entries/.test(url)) {
        return 'entry';
      } else if (/comments/.test(url)) {
        return 'comment';
      }
    },

    setNudgingCardClasses(modifier) {
      const nudgingCard = this.$el.querySelector('.nudging__card');
      nudgingCard.classList.remove('nudging__card--positive', 'nudging__card--neutral', 'nudging__card--negative');
      nudgingCard.classList.add(`nudging__card--${modifier}`);
      nudgingCard.classList.remove('hidden');
    },

    setNudgingIconClasses(modifier) {
      const nudgingIcon = this.$el.querySelector('.nudging__icon');
      nudgingIcon.classList.remove(
        'fa-face-smile',
        'fa-face-meh',
        'fa-face-frown',
        'nudging__icon--positive',
        'nudging__icon--neutral',
        'nudging__icon--negative'
      );
      nudgingIcon.classList.add(`fa-face-${icons[`${modifier}`]}`, `nudging__icon--${modifier}`);
    },

    setNudgingMessage(message) {
      this.$el.querySelector('.nudging__message').innerHTML = message;
    },

    async callAiFeedback(e) {
      const body = { ai_feedback: {} };
      body.ai_feedback.content = e.detail;

      const token = document.querySelector('meta[name=csrf-token]')?.getAttribute('content');
      // The endpoint serves JSON only (respond_to { |format| format.json }). Ask for it
      // explicitly rather than leaning on fetch's default Accept: */*, which Rails
      // resolves to the first declared format by coincidence.
      const request = new Request(this.url, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(body),
      });

      let data;
      try {
        const response = await fetch(request);
        if (!response.ok) return;
        data = await response.json();
      } catch {
        return;
      }
      if (data.modifier && data.message) {
        this.showNudging = true;
        this.setNudgingMessage(data.message);
        this.setNudgingCardClasses(data.modifier);
        this.setNudgingIconClasses(data.modifier);
      }
    },
  };
}
